import { deleteRequest, get, post, put } from 'api';
import queryClient from 'query-client';
import { MutationOptions } from 'hooks/types';
import { GenericAPIResponse } from 'types/generic';
import { QueryOptions, useMutation, useQuery } from 'react-query';
import {
  ILiveClass,
  IGetLiveClass,
  IGetLiveClassList,
  ICreateLiveClassFormValues,
} from 'types/liveClass';

export const useLiveClassList = (options?: QueryOptions<IGetLiveClassList>) => {
  return useQuery<IGetLiveClassList, any>(
    ['liveClasses/liveClasslist'],
    () => get('live_classes'),
    {
      ...(options || {}),
      cacheTime: 0,
      retry: false,
    },
  );
};

export const useLiveClassQuery = (id: string, options?: QueryOptions<IGetLiveClass>) => {
  return useQuery<IGetLiveClass, any>(
    ['liveClasses/liveClass', id],
    () => get(`live_classes/${id}`),
    {
      ...(options || {}),
      cacheTime: 0,
      retry: false,
    },
  );
};

export const useUpdateLiveClassMutation = (
  id: string,
  options?: MutationOptions<GenericAPIResponse<ILiveClass>>,
) => {
  return useMutation((value: ICreateLiveClassFormValues) => put(`live_classes/${id}`, value), {
    ...(options || {}),
    onSettled: () => {
      queryClient.invalidateQueries('liveClasses/liveClasslist');
      queryClient.invalidateQueries(['liveClasses/liveClass']);
    },
  });
};

export const useCreateLiveClassMutation = (
  sessionId: string,
  options?: MutationOptions<GenericAPIResponse<ILiveClass>>,
) => {
  return useMutation(
    (value: ICreateLiveClassFormValues) => post(`basic_sessions/${sessionId}/live_class`, value),
    {
      ...(options || {}),
    },
  );
};

export const useDeleteLiveClass = (options?: MutationOptions<GenericAPIResponse<any>>) => {
  return useMutation((id: string) => deleteRequest(`live_classes/${id}`), {
    ...(options || {}),
    onSettled: () => {
      queryClient.invalidateQueries('liveClasses/liveClasslist');
    },
  });
};
